import { motion } from 'motion/react';
import { formatCurrency } from '../utils/Currency';
import { prepareDataAttributesObject } from '../utils/HtmlUtils';
import './SimpleSwitch.scss';

const SimpleSwitch = ({ checked, onClick, price, showPrice = false, name, showChecked = true, className = '', data, disabled = false }) => {
    var classes = ["SimpleSwitch", className];
    if (checked) {
        classes.push("SimpleSwitch--checked");
    }
    if (showChecked) {
        classes.push("SimpleSwitch--showChecked");
    }
    if (disabled) {
        classes.push('disabled');
    }
    if (showPrice) {
        classes.push('SimpleSwitch--showPrice');
    }
    return (
        <button

            className={classes.join(" ")} onClick={onClick} {...prepareDataAttributesObject(data)} disabled={disabled}>
            <div className="SimpleSwitch__name">{name}</div>
            <div className="SimpleSwitch__price">{price !== null ? formatCurrency(price, { hideBlank: false, showSign: true }) : null}</div>

            {
                (checked && showChecked) ? (
                    <svg
                        className="SimpleSwitch__icon"
                        width={18}
                        height={18}
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M-0.000488281 0H17.1424V14.5714C17.1424 16.465 15.6073 18 13.7138 18H-0.000488281V0Z"
                            fill="black"
                        />
                        <path
                            d="M4.99951 8.57139L7.99951 11.1428L12.8569 6"
                            stroke="white"
                            strokeWidth="0.857143"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>

                ) : null
            }

        </button>
    );
};

export default SimpleSwitch;